"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bridgeObjectChanged = exports.bridgeObjectRemoved = exports.bridgeObjectAdded = void 0;
// Group: BridgeSync
// Notifications sent when some bridge object is added, changed or removed
// Sent when bridge object was added to the service
// 'identifier' - id of added bridge object; 'object' - entire bridge object
exports.bridgeObjectAdded = 'BridgeObjectAdded';
// Sent when bridge object was removed from the service
// 'identifier' - id of removed bridge object
exports.bridgeObjectRemoved = 'BridgeObjectRemoved';
// Sent when remote version of bridge object was changed
// 'identifier' - id of changed object; 'keyPath' - key path to the place where changes took place; 'changes' - changes that need to be applied to local bridge object with id at keyPath
exports.bridgeObjectChanged = 'BridgeObjectChanged';
